var render, staticRenderFns
import script from "./Preview.vue?vue&type=script&lang=ts"
export * from "./Preview.vue?vue&type=script&lang=ts"
import style0 from "./style.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports